import React from 'react';
import styles from './Loader.module.scss';

const Loader = () => {
	return (
		<div className={styles.loaderContainer}>
			<div className={styles.loaderFill}></div>
		</div>
	);
};

export default Loader;
